import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@mui/material/Box";
import WwMain from "../../../Components/Card/AssetUI/ILT/WwMain";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "presentation",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 1,
};

const ILT = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [logObj, setLogObj] = useState(initLogObj);

  useEffect(() => {
    if (props.content) {
      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: [],
      });
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
  }, [logObj]);

  return (
    <Box component="div"   sx={{'@media (max-width: 1024px)' : { zoom: '0.73'} }}>
      {props.content && props.content.epage.options.content.content && 
        <WwMain data={props.content.epage.options.content.content} actions={props.content.epage.options.content.action_button}></WwMain>
      }
    </Box>
  );
};

const useStyles = makeStyles({
    ListItemText: {
      fontSize: "1rem !important",
    },
    scrollBar: {
      "&::-webkit-scrollbar": {
        width: "0.2em",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#ffe600ff",
        "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
        borderRadius: 5,
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#DB8829",
        borderRadius: 5,
      },
      height: '76vh',
      overflow: 'auto',
      margin: '5px',
    },
    scrollBarHeight: {
      "&::-webkit-scrollbar": {
        height: "0.2em",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#ffe600ff",
        "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
        borderRadius: 5,
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#DB8829",
        borderRadius: 5,
      },
    },
  });

export default ILT;
